eshopApp.controller('CategoriesNavController', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope) {

	// Sorting defaults
	$scope.order = 'name';
	$scope.sort = 'asc';
	$scope.limit = '1000';
	$scope.page = '1';

	// Get categories
	$scope.fetch = function(){
		$http.get('/m/categories', {
			params: {
				order: $scope.order,
				sort: $scope.sort,
				limit: $scope.limit,
				page: $scope.page
			}
		}).success(function(response){
			$scope.categories = response;

	  	});
	};

	$scope.fetch(); // Init
}]);
